import React from "react";
import {
  GenericTextField,
  GenericNumberField,
  GenericDateField,
  GenericCheckboxField,
  GenericLookupField,
  GenericTextFieldProps,
  GenericNumberFieldProps,
  GenericDateFieldProps,
  GenericCheckboxFieldProps,
  GenericLookupFieldProps,
} from "../../../../components/common/FormFields";

// Trailer-specific typed versions of generic components
export const TrailerTextField: React.FC<GenericTextFieldProps> = (props) => (
  <GenericTextField {...props} />
);

export const TrailerNumberField: React.FC<GenericNumberFieldProps> = (props) => (
  <GenericNumberField {...props} />
);

export const TrailerDateField: React.FC<GenericDateFieldProps> = (props) => (
  <GenericDateField {...props} />
);

export const TrailerCheckboxField: React.FC<GenericCheckboxFieldProps> = (props) => (
  <GenericCheckboxField {...props} />
);

export const TrailerLookupField: React.FC<GenericLookupFieldProps> = (props) => (
  <GenericLookupField {...props} />
);
